import { HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_ERROR_MESSAGE = new HttpContextToken<boolean>(() => false);
